/**
 * ChartMind-I access subscription — chartMindIAccess/{uid}.
 */
import { db } from "services/firebase";
import { CHART_MIND_I_ACCESS_COLLECTION } from "../chartMindIConstants";

export function subscribeToChartMindIAccess(uid, onData) {
  if (!uid) {
    onData(null);
    return () => {};
  }
  return db
    .collection(CHART_MIND_I_ACCESS_COLLECTION)
    .doc(uid)
    .onSnapshot(
      (snap) => {
        onData(snap.exists ? snap.data() : null);
      },
      (err) => {
        console.warn("[chartMindIAccess] subscription failed", err);
        onData(null);
      },
    );
}
